import { ProfileView } from "./ProfileView";
import { useProfileData } from "./useProfileData";

interface ProfileProps {
    isProdMode: boolean;
    commitHash: string;
}

export function Profile({ commitHash }: ProfileProps) {
    const profileData = useProfileData({ commitHash });
    return <ProfileView profileData={profileData} />;
}
